import React from 'react'

export const ProductType = {
  BPU: { name: 'Bullying Prevention Unit', skuCode: 'BPU' },
  CPU: { name: 'Child Protection Unit', skuCode: 'CPU' },
  K5: { name: 'Elementary', skuCode: 'K5P' },
  MSP: { name: 'Middle School', skuCode: 'MSP' },
  OST: { name: 'Out-of-School Time', skuCode: 'OST' },
  SSP: { name: 'Second Step Program K-5', skuCode: 'SSP' },
  SSPEL: { name: 'Early Learning', skuCode: 'SSPEL' },
}

export const GRADE_K2_TIERED_INTERVENTIONS = 'k-2_curriculum_tier2'
export const GRADE_35_TIERED_INTERVENTIONS = '3-5_curriculum_tier2'
export const GRADE_68_TIERED_INTERVENTIONS = '6-8_curriculum_tier2'

export const K5_PROGRAM_TYPE = 'k5SelDigital'
export const MSP_PROGRAM_TYPE = 'mspDigital'
export const HIGH_SCHOOL_PROGRAM_TYPE = 'highSchool'

/**
 * Maps program codes (K5P, MSP, HSP) to program keys (k5SelDigital, mspDigital, highSchool)
 * Used for converting between API program codes and userAccess/userContext program keys
 */
export const PROGRAM_CODE_TO_KEY_MAP = {
  K5P: K5_PROGRAM_TYPE,
  MSP: MSP_PROGRAM_TYPE,
  HSP: HIGH_SCHOOL_PROGRAM_TYPE,
}

export const TICourseNameToProgramMap = {
  [GRADE_K2_TIERED_INTERVENTIONS]: K5_PROGRAM_TYPE,
  [GRADE_35_TIERED_INTERVENTIONS]: K5_PROGRAM_TYPE,
  [GRADE_68_TIERED_INTERVENTIONS]: MSP_PROGRAM_TYPE,
}

export const OVERALL_PROGRAM_LIST = [
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
  HIGH_SCHOOL_PROGRAM_TYPE,
]

export const TIERED_INTERVENTION_PROGRAM_LIST = [
  K5_PROGRAM_TYPE,
  MSP_PROGRAM_TYPE,
]

// NOTE: for products onboarded to the the new subnav system,
// please add a title field to their object if you want them to have a title in the global nav

// THIS IS THE OFFICIAL PRODUCTION TEACH
// TODO [LEARN-8585]: remove skuCode and productType mapping from learn
export const admin = {
  defaultPage: 'implementation-guide',
  name: 'Admin',
  themeName: 'platform',
  title: (
    <span>
      Second Step<sup>®</sup> Leader Dashboard
    </span>
  ),
}

export const dashboard = {
  name: 'Dashboard',
  themeName: 'platform',
  title: (
    <span>
      Second Step<sup>®</sup> Programs
    </span>
  ),
}

export const district = {
  defaultPage: 'supports',
  name: 'District Supports',
  productName: 'district-supports',
  themeName: 'platform',
}

export const elementary = {
  alternateNames: ['grades-k-5', 'elementary'],
  defaultPage: 'teach',
  entryPoint: '3DURyazBws2DBVtEjYUPUR',
  lmsKey: 'Elementary',
  lmsKeyV2: 'K5SelDigital',
  name: 'Elementary',
  productName: 'elementary',
  skuCode: ProductType.K5.skuCode,
  themeName: 'elementary',
  title: 'Elementary Digital Program',
}

export const familyMindYeti = {
  defaultPage: 'playlists-and-supports',
  name: 'Mind Yeti',
  themeName: 'mindyeti',
}

export const familyResources = {
  defaultPage: 'elementary',
  name: 'Family Resources',
  themeName: 'familyResources',
  title: 'K–8 Digital Program Resources',
}

export const familyResourcesHS = {
  defaultPage: 'high-school',
  name: 'Family Resources',
  themeName: 'familyResources',
  title: 'High School Resources',
}

export const middleSchool = {
  alternateNames: ['grades-6-8', 'middle-school'],
  defaultPage: 'teach',
  entryPoint: '6V4P1pYzF8TMGKzNcPNG9B',
  lmsKey: 'Classes',
  lmsKeyV2: 'MspDigital',
  lmsKeyV1Dot5: 'MiddleSchool',
  name: 'Middle School',
  productName: 'middle-school',
  skuCode: ProductType.MSP.skuCode,
  themeName: 'middleSchool',
  title: 'Middle School',
}

export const mindYeti = {
  defaultPage: 'mind-yeti',
  entryPoint: '54apwXMO0wRboRsiy1KIvh',
  name: 'Mind Yeti',
  productName: 'mind-yeti',
  skuCode: null,
  themeName: 'mindyeti',
}

export const reports = {
  name: 'Reports',
  themeName: 'platform',
}

export const selForAdults = {
  defaultPage: 'modules',
  entryPoint: '5c2NEfz76UcLUugDvS8AOo',
  name: 'SEL for Adults',
  productName: 'sel-for-adults',
  skuCode: null,
  themeName: 'sela',
}
export const selForAdultsFieldTest = {
  defaultPage: 'modules',
  entryPoint: 'd9i22xTOiLdwnILB0iUSn',
  name: 'SEL for Adults Field Test',
  productName: 'sel-for-adults-field-test',
  skuCode: null,
  themeName: 'sela',
}

export const highSchool = {
  alternateNames: ['grades-9-12', 'high-school'],
  defaultPage: 'pathways',
  entryPoint: '4jWxfsChj2S6ZgIyzA2ACF',
  name: 'High School',
  productName: 'high-school',
  skuCode: 'HSP',
  themeName: 'highschool',
  title: 'High School',
}

// TODO: All of these should be removed once Planet EXPRESS dynamically adds top level keys to redux

export const k5Kit = {
  alternateNames: ['Second Step Elementary'],
  defaultPage: 'training',
  entryPoint: '7wz0n0pOvPPvF7lidBqyJa',
  name: 'Elementary Classroom Kits',
  productName: 'k5kit',
  skuCode: ProductType.SSP.skuCode,
  themeName: 'k5kit',
}

export const bpuKit = {
  defaultPage: 'training',
  entryPoint: '2ttriSkjEXDpDBnaG246Mt',
  name: 'Bullying Prevention Unit',
  productName: 'bpu',
  skuCode: ProductType.BPU.skuCode,
  themeName: 'bpu',
}

export const cpuKit = {
  defaultPage: 'training',
  entryPoint: '3RkEFGHWSJE1bWzdZFyKwN',
  name: 'Child Protection Unit',
  productName: 'cpu',
  skuCode: ProductType.CPU.skuCode,
  themeName: 'cpu',
}

export const elKit = {
  entryPoint: '3jbBI2DbMy17Eh4eHF4dN7',
  name: 'Early Learning',
  productName: 'elkit',
  skuCode: ProductType.SSPEL.skuCode,
  themeName: 'elkit',
}

export const msKit = {
  alternateNames: ['Grades 6–8 Classroom Kits'],
  defaultPage: 'teach',
  entryPoint: '5xTGruXnEfVhnJW2ztEMaW',
  name: 'Middle School Kit',
  productName: 'mskit',
  skuCode: ProductType.MSP.skuCode,
  themeName: 'mskit',
}

export const outOfSchoolTime = {
  defaultPage: 'program-supports',
  entryPoint: 'C1bnxN0N5hhttOeJeF81e',
  name: 'Out-of-School Time',
  productName: 'ost',
  skuCode: ProductType.OST.skuCode,
  themeName: 'ostKit',
}

export const outOfSchoolTimeK1 = {
  defaultPage: 'program-supports',
  entryPoint: 'C1bnxN0N5hhttOeJeF81e',
  name: 'Out-of-School Time K1',
  productName: 'ost',
  skuCode: ProductType.OST.skuCode,
  themeName: 'ostKitK1',
}

export const outOfSchoolTime23 = {
  defaultPage: 'program-supports',
  entryPoint: 'C1bnxN0N5hhttOeJeF81e',
  name: 'Out-of-School Time 23',
  productName: 'ost',
  skuCode: ProductType.OST.skuCode,
  themeName: 'ostKit23',
}

export const outOfSchoolTime45 = {
  defaultPage: 'program-supports',
  entryPoint: 'C1bnxN0N5hhttOeJeF81e',
  name: 'Out-of-School Time 45',
  productName: 'ost',
  skuCode: ProductType.OST.skuCode,
  themeName: 'ostKit45',
}

// this default export is used to map the route (eg "bpu-kit") to a product
export default {
  admin,
  bpuKit,
  cpuKit,
  district,
  elKit,
  elementary,
  familyMindYeti,
  familyResources,
  familyResourcesHS,
  // hack, point this entry at high school because we query it by url path:
  family: familyResourcesHS,
  k5Kit,
  middleSchool,
  mindYeti,
  msKit,
  outOfSchoolTime,
  outOfSchoolTimeK1,
  outOfSchoolTime23,
  outOfSchoolTime45,
  reports,
  selForAdults,
  selForAdultsFieldTest,
  highSchool,
}

export const RouteContentProductAppMap = {
  learnOrphans: 'learnOrphans',
  learnFamilyResourcesHS: 'learnFamilyResourcesHS',
  learnFamilyResourcesK8: 'learnFamilyResourcesK8',
  learnMsProduct: 'learnMsProduct',
  learnHsProduct: 'learnHsProduct',
  learnK5Product: 'learnK5Product',
}

export const OptionalUnits = {
  BullyingHarassmentUnit: {
    slug: 'recognizing-bullying-and-harassment',
    // FIX: Hopefully its temporary and there will be a better to identify H&B lessons in Course Manager.
    courseNodeIds: [
      'X5S6Sit9WKHgMRbXYQOs1',
      '2H6iYvNCaE86l3RBvbIr3O',
      '33Gc0lwEcMNAtcE2a2Znkh',
    ],
  },
}

// TODO: these internalTitle values were auto-generated by GitHub copilot
// need to replace them with the correct values
// the entry id values are correct already
export const elementaryV2ContentfulMappings = [
  {
    courseName: 'k',
    displayTitle: 'Grade K',
    internalTitle: 'Grade K, ElemDigital ',
    id: '6IfdgJVUG6IpK1QXeMPiNU',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '1',
    displayTitle: 'Grade 1',
    internalTitle: 'Grade 1, ElemDigital',
    id: '3CEV7ZzA2kUwg9o3jVbZPb',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '2',
    displayTitle: 'Grade 2',
    internalTitle: 'Grade 2, ElemDigital',
    id: '7mXOmpE9MjFyXtSz1zyIhF',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '3',
    displayTitle: 'Grade 3',
    internalTitle: 'Grade 3, ElemDigital',
    id: '2uAtX2IqOvTJuERHUhyupL',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '4',
    displayTitle: 'Grade 4',
    internalTitle: 'Grade 4, ElemDigital',
    id: '5bJhDzZQUU2GahVcCsYPRa',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '5',
    displayTitle: 'Grade 5',
    internalTitle: 'Grade 5, ElemDigital',
    id: '2z9CNsFLrmLSd11uM9KpDk',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: 'k-2_curriculum_tier2',
    displayTitle: 'Grade K-2',
    internalTitle: 'grade k-2 course - k8 tier2 - root',
    id: '6T2703qI3n8KaHvLYR8X1W',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
  {
    courseName: '3-5_curriculum_tier2',
    displayTitle: 'Grade 3-5',
    internalTitle: 'grade 3-5 course - k8 tier2 - root',
    id: '7091GjQgPmg4WE64S04sej',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
]

// TODO: This is a mapping for the new Contentful ids for Middle School and is a hack to override old Contentful Ids until Program Flex is fully implemented
export const middleSchoolV2ContentfulMappings = [
  {
    courseName: '6',
    displayTitle: 'Grade 6',
    internalTitle: 'Grade 6, MSdigital',
    id: '3MGuMC1rZH4HDF3MNKj3b4',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '7',
    displayTitle: 'Grade 7',
    internalTitle: 'Grade 7, MSdigital',
    id: '1k9vPryVAuk0XG4pU9IwnI',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '8',
    displayTitle: 'Grade 8',
    internalTitle: 'Grade 8, MSdigital',
    id: '5mhIMAgQUP2RgAxfC3ucyD',
    shouldShowOnLessonsPage: true,
  },
  {
    courseName: '6-8_curriculum_tier2',
    displayTitle: 'Grade 6-8',
    internalTitle: 'grade 6-8 course - k8 tier2 - root',
    id: '6zJmyzNhKbMQRj2rhd8lM7',
    defaultUnit: 'emotions-thoughts-feelings',
    shouldShowOnLessonsPage: false,
  },
]

export const k8V2ContentfulMappings = [
  ...elementaryV2ContentfulMappings,
  ...middleSchoolV2ContentfulMappings,
]

export const programKeyMap = {
  elementary: 'K5SelDigital',
  'middle-school': 'MspDigital',
  highSchool: 'HighSchool',
}
